import { getConnectionPool } from "../../core/connectionPool";
import { checkMigrate } from "../../init/sdkInit";
import { request, response } from "../../proto/bundle";

export class ActionEntry{
   subject:string;
   subjectType:string;
   action:string;
   opIds:Uint32Array;
   constructor(subject:string,subjectType:string,action:string,opIds:Uint32Array){
    this.action=action;
    this.subject=subject;
    this.subjectType=subjectType;
    this.opIds=opIds;
   }
};

export class UserMeta {
    email: string;
    profilePicture: Uint8Array;

    constructor(email: string, profilePicture?: Uint8Array) {
        this.email = email;
        this.profilePicture = profilePicture ?? new Uint8Array();
    }

    getEmail(): string {
        return this.email;
    }

    setEmail(email: string): void {
        this.email = email;
    }

    getProfilePicture(): Uint8Array {
        return this.profilePicture;
    }

    setProfilePicture(pictures: Uint8Array): void {
        this.profilePicture = pictures;
    }
}

export class  Entry{
    action:string;
    ops:string[];
    subjectType:string;
    subject:string;

    constructor(){

    }

    getSubject(): string{
        return this.subject;
    }
   getSubjectType():string{
    return this.subjectType;
   }

   getAction():string{
    return this.action;
   }

   getOps():string[]{
    return this.ops;
   }
};
export class Share{
    parent_path:string;
    entries:request.ActionEntry[]= [];
    owner:string;
    constructor(parentPath:string,owner:string){
        this.parent_path=parentPath;
        this.owner=owner;
        this.entries=[];
    }
    getReadOpIds():number[]{
        return [17,21,29,25,108,109,110,112];
    }
    getReadOpIdsForDeny():number[]{
        return [21,29,25,108,112,110,109]
    }
    getWriteOpIds():number[]{
         return  [17,22,25,23, 24,30,66,107,110,111];
    }
    getWriteOpIdsForDeny():number[]{
         return  [22,23, 24,30,66,107,111];
    }
    getCopyOpIds():number[]{
        return [17,52,53,27,25];
    }
    getCopyOpIdsForDeny():number[]{
        return [52,53,27];
    }
    getOpIdsFromStringForDeny(i: number): number[] {
        if (i==1){
            return this.getReadOpIdsForDeny();
        }else if(i==2){
            return this.getWriteOpIdsForDeny();
        }else if(i==3){
            return this.getCopyOpIdsForDeny();
        }else{
            return [];
        }
    }


    getOpIdsFromString(i: number): number[] {
        if (i==1){
            return this.getReadOpIds();
        }else if(i==2){
            return this.getWriteOpIds();
        }else if(i==3){
            return this.getCopyOpIds();
        }else{
            return [];
        }
    }

    getOperationFromId(ids: number[]): string[] {
        let operations: string[] = [];
        const idSet = new Set(ids);

        if (this.getReadOpIds().every(id => idSet.has(id))) {
            operations.push("Read");
        }
        if (this.getWriteOpIds().every(id => idSet.has(id))) {
            operations.push("Write");
        }
        if (this.getCopyOpIds().every(id => idSet.has(id))) {
            operations.push("Copy");
        }

        return operations;
    }
    getDenyOperationFromId(ids: number[]): string[] {
        let operations: string[] = [];
        const idSet = new Set(ids);

        if (this.getReadOpIdsForDeny().every(id => idSet.has(id))) {
            operations.push("Read");
        }
        if (this.getWriteOpIdsForDeny().every(id => idSet.has(id))) {
            operations.push("Write");
        }
        if (this.getCopyOpIdsForDeny().every(id => idSet.has(id))) {
            operations.push("Copy");
        }

        return operations;
    }
    async addEntry(entry: ActionEntry): Promise<void> {
    // console.log("Add entry is called in sdk");
    // console.log("Acl Entry",entry);
    // console.log("OpIds",entry.opIds);
    let opids = entry.opIds;
    let arr: number[] = [];
    if (entry.action=="DENY"){
     for (let i = 0; i < opids.length; i++) {
        arr.push(...this.getOpIdsFromStringForDeny(opids[i]));
    }


    }
    else{
    for (let i = 0; i < opids.length; i++) {
        arr.push(...this.getOpIdsFromString(opids[i]));
    }
    }


    const uniqueOpIds = Array.from(new Set(arr));


    const action: request.Action = entry.action === "ALLOW"
        ? request.Action.ALLOW
        : request.Action.DENY;

    const subject_type: request.SubjectType = entry.subjectType === "USER"
        ? request.SubjectType.USER
        : request.SubjectType.TEAM;

    const acl_entry: request.ActionEntry = request.ActionEntry.create({
        action: action,
        subject: entry.subject,
        subjectType: subject_type,
        opIds: uniqueOpIds,
    });

    this.entries.push(acl_entry);
}


    async listTeamOfUsers(): Promise<string[]> {
        // console.log("List team of users is called");
        const pool = await getConnectionPool();
        let req = request.Request.create({
            id: null,
            reqCreateTime: Date.now(),
            getRolesAndTeamsOfUser: request.GetRolesAndTeamsOfUser.create({
            emailOfUser: this.owner,
            }),
        });

        const resp = await pool.sendAndWait(req);

        checkMigrate(resp.getRolesAndTeamsOfUser.status)
        if (!resp.getRolesAndTeamsOfUser) {
            throw new Error(`Failed to get teams of user ${resp.getRolesAndTeamsOfUser?.status})`);
        }

        const result = resp.getRolesAndTeamsOfUser;
        if (result.status !== response.Status.SUCCESS) {
            throw new Error("Failed to get teams of user");
        }

        return result.nameOfTeams || [];
    }

async listUsers(): Promise<{ userMetas: UserMeta; teamsOfUser: string[]; rolesOfUser: string[] }[]> {
    const pool = await getConnectionPool();
    let usersList: { userMetas: UserMeta; teamsOfUser: string[]; rolesOfUser: string[] }[] = [];
    let pageToken: Uint8Array | undefined = undefined;
    const Email=pool.getEmail();
    while (true) {
        const req = request.Request.create({
            id: null,
            reqCreateTime: Date.now(),
            listUsers: request.ListUsers.create({
                pageTokenListUser: pageToken,
                pageSize: pageToken ? undefined : 20,
            }),
        });

        const resp = await pool.sendAndWait(req);
        checkMigrate(resp.listUsers.status)

        if (!resp.listUsers || resp.listUsers.status !== response.Status.SUCCESS) {
            throw new Error(`Failed to list users (${resp.listUsers?.status})`);
        }

        const result = resp.listUsers;

        for (const user of result.users || []) {
            if (user.email === Email) {
                continue;
            }
            usersList.push({
            userMetas: new UserMeta(user.email || "", user.profilePicture || new Uint8Array()),
            teamsOfUser: pageToken ? [] : user.teamsOfUser || [],
            rolesOfUser: pageToken ? [] : user.rolesOfUser || [],
            });
        }

        pageToken = result.pageTokenListUser ?? undefined;

        if (!pageToken || pageToken.length === 0) {
            break; // End of pagination
        }
    }
    // console.log("Users List:", usersList);
    return usersList;
}


    async share():Promise<void>{
        const pool = await getConnectionPool();
        // console.log("Share is called");
        const share_req = request.Request.create({
            id: null,
            reqCreateTime: Date.now(),
            share: request.Share.create({
                acl:request.ACL.create({
                    objectPath:this.parent_path,
                    ownerEmail:this.owner,
                    actions:this.entries,
                }),
            }),
        });

        const resp = await pool.sendAndWait(share_req);
        checkMigrate(resp.share.status)

        if (!resp.share || resp.share.status !== response.Status.SUCCESS) {
            throw new Error(`Failed to share object (${resp.share?.status})`);
        }
        this.entries = [];
        return;
    }
    async updateShare():Promise<void>{
        // console.log("Update share is called");
        const pool = await getConnectionPool();
        const req=request.Request.create({
            id:null,
            reqCreateTime: Date.now(),
            updateShare:request.UpdateShare.create({
                acl:request.ACL.create({
                    objectPath:this.parent_path,
                    ownerEmail:this.owner,
                    actions:this.entries,
                }),
            }),
        });

        const resp=await pool.sendAndWait(req);
        checkMigrate(resp.updateShare.status)

        if (!resp.updateShare || resp.updateShare.status !== response.Status.SUCCESS) {
            throw new Error(`Failed to update share (${resp.updateShare?.status})`);
        }
        this.entries=[];
        return ;
    }

async listShares(): Promise<Entry[]> {
    // console.log("listShares is called");

    const pool = await getConnectionPool();

    const req = request.Request.create({
        id: null,
        reqCreateTime: Date.now(),
        listShares: request.ListShares.create({
            objectPath: this.parent_path,
        }),
    });

    const resp = await pool.sendAndWait(req);
    checkMigrate(resp.listShares.status)

    if (!resp.listShares || resp.listShares.status !== response.Status.SUCCESS) {
        throw new Error(`Failed to list shares (${resp.listShares?.status})`);
    }

    const aclBytes = resp.listShares.acl;

    // console.log("Acl Bytes",aclBytes);
    if (!(aclBytes instanceof Uint8Array)) {
        console.warn("ACL data is missing or in wrong format");
        return [];
    }

    let decodedAcl: any;
    try {
        decodedAcl = request.ACL.decode(aclBytes);
        if (!decodedAcl || !Array.isArray(decodedAcl.actions) || decodedAcl.actions.length === 0) {
            console.warn("Decoded ACL is empty or has no actions");
            return [];
        }
    } catch (e) {
        console.error("Error decoding ACL bytes:", e);
        return [];
    }
    // console.log("Decoded ACL:", decodedAcl);

    const result: Entry[] = [];

    const actions = decodedAcl.actions || [];
    // console.log("decoded acls",decodedAcl);
    for (const action of actions) {
        const entry = new Entry();
        entry.action = action.action === 0 ? "ALLOW"
                        : action.action === 1 ? "DENY"
                        : "UNKNOWN";
        entry.ops = entry.action === "ALLOW" ? this.getOperationFromId(action.opIds ? Array.from(action.opIds) : []) : this.getDenyOperationFromId(action.opIds ? Array.from(action.opIds) : []);
        entry.subjectType = action.subjectType === 0 ? "USER"
                            : action.subjectType === 1 ? "TEAM"
                            : "UNKNOWN";
        entry.subject = action.subject || "";
        result.push(entry);
    }

    // console.log("Results",result);
    return result;
}


    async unShare():Promise<void>{
        // console.log("unshare  is called");
        const pool = await getConnectionPool();
        const req = request.Request.create({
            id: null,
            reqCreateTime: Date.now(),
            unshare: request.Unshare.create({
            objectPath: this.parent_path,
            }),
        });

        const resp = await pool.sendAndWait(req);
        checkMigrate(resp.unshare.status)

        if (!resp.unshare || resp.unshare.status !== response.Status.SUCCESS) {
            throw new Error(`Failed to unshare object (${resp.unshare?.status})`);
        }
        return;
    }

};
